"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (panel, logoStyle, isOpen, appBarHeight, containerPadding, isVertical, withRightIconsOnToggle) { return ({
    main: {},
    panel: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        transition: panel.transitionTime,
        position: 'fixed',
        left: isOpen ? 0 : -1 * panel.sidebarWidth + (withRightIconsOnToggle ? 50 : 0),
        top: panel.top || 0,
        height: isVertical ? '100%' : '65px',
        width: isVertical ? panel.sidebarWidth : '100%',
        backgroundColor: panel.backgroundColor,
        zIndex: 999,
    },
    sidebarWrapper: {
        overflowY: isVertical ? 'auto' : 'visible',
        marginTop: isVertical ? (appBarHeight > 0 ? panel.logoHeight + appBarHeight : panel.logoHeight) : 0,
        marginLeft: isVertical ? 0 : logoStyle.wrapperWidth,
        position: isOpen && 'fixed',
        height: isVertical ? "calc(100% - " + (panel.logoHeight + appBarHeight + 60) + "px)" : 'auto',
        width: isVertical ? panel.sidebarWidth : "calc(100% - " + logoStyle.wrapperWidth + "px)",
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    sidebar: {
        padding: '8px 0px',
        display: isVertical ? 'block' : 'flex',
        overflowX: !isVertical && 'auto',
    },
    sidebarRight: {
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'flex-end',
    },
    sidebarVersion: {
        position: 'fixed',
        bottom: 0,
        width: panel.sidebarWidth,
        textAlign: 'center',
    },
    burger: {
        transition: panel.transitionTime,
        marginTop: isOpen ? -50 : 0,
        position: 'absolute',
        zIndex: 1000,
        color: 'black',
    },
    container: {
        display: !isVertical ? 'flex' : 'block',
        flexWrap: 'wrap',
        transition: panel.transitionTime,
        overflowY: 'auto',
        padding: appBarHeight + containerPadding + "px " + containerPadding + "px " + containerPadding + "px " + containerPadding + "px",
        marginLeft: isVertical ? (isOpen ? panel.sidebarWidth : 50) : 0,
        maxWidth: '100vw',
        boxSizing: 'border-box',
    },
    logo: {
        transition: panel.transitionTime,
        position: isOpen ? 'fixed' : 'absolute',
        left: isOpen ? 0 : -1 * panel.sidebarWidth,
        width: isVertical ? panel.sidebarWidth : 200,
        marginTop: isVertical ? appBarHeight : 0,
        a: {
            cursor: 'pointer',
            color: 'white',
            textDecoration: 'none',
            fontSize: '1.2em',
            height: panel.logoHeight,
            alignItems: 'center',
            justifyContent: 'space-between',
            display: 'flex',
        },
        img: __assign({ height: '80%' }, logoStyle),
    },
    svgIcon: {
        color: 'black',
    },
}); });
//# sourceMappingURL=styles.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/app/Sidebar/styles.js
// module id = 1867
// module chunks = 0